import { ActionCustomEventGTM } from './common/event';
import { ANALYTIC_EVENT_EVENTS, ANALYTIC_EVENT_LABELS } from './constants';

export class ChangeSortingEventGTM extends ActionCustomEventGTM {
  constructor(eventContent: string) {
    super(ANALYTIC_EVENT_EVENTS.click, eventContent, ANALYTIC_EVENT_LABELS.sorting);
  }
}

export class SetCurrentSortTypeEvent {
  sortType: string;

  constructor(sortType: string) {
    this.sortType = sortType;
  }
}

export interface CounterInteractionCollection {
  actionType?: string;
  pageType?: string;
  name?: string;
  id?: string;
  price?: string;
  brand?: string;
  category?: string;
  quantity?: number;
  indexPosition?: number;
  eventContent?: string;
  deliveryAlias?: string;
  categoryId?: number;
}
